// extracted by css-extract-rspack-plugin
export default {"hide-on-desktop":"ToolbarMoreMenu-module__hide-on-desktop__Gv48M","show-on-mobile":"ToolbarMoreMenu-module__show-on-mobile__DX3B0"};